import { EPlanType, IProfileUser } from '../../interfaces/src'

export const calculateUserPlan = (
  profileUser: IProfileUser
): EPlanType | undefined => {
  const primeType = profileUser?.primeType as EPlanType
  const planType = profileUser?.planType as EPlanType

  if (planType === EPlanType.ADVANCED || primeType === EPlanType.ADVANCED) {
    return EPlanType.ADVANCED
  }

  if (planType === EPlanType.STARTER || primeType === EPlanType.STARTER) {
    return EPlanType.STARTER
  }

  if (planType === EPlanType.TRIAL || primeType === EPlanType.TRIAL) {
    return EPlanType.TRIAL
  }

  return undefined
}
